// Buttons as shopusars.com draws them: blue for the action, white with navy text beside it.

export const ctaButton =
  'bg-usa-blue hover:bg-usa-blue-dark h-11 rounded-[4px] px-5 text-xs font-bold tracking-wider text-white uppercase'

export const secondaryButton =
  'text-usa-navy hover:bg-usa-tint hover:text-usa-navy h-11 rounded-[4px] border-border bg-white px-5 text-xs font-bold tracking-wider uppercase'
